function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useCallback } from 'react';
import fetch from '@rd-web-markets/shared/dist/services/Fetcher';
import { request } from '@rd-web-markets/shared/dist/services/request';
import { useErrorHandling } from '@rd-web-markets/shared/dist/hooks/useErrorHandling';
import claimGroupService from './claim_group.service';
const userAccessService = {
  useCreateUserAccess(claimGroup, setLoading, setClaimGroup, setSelectedUserAccess, setEngagementTeam) {
    return useErrorHandling(useCallback(async userAccess => {
      setLoading && setLoading(true);
      const newUserAccess = await userAccessService.create(claimGroup.id, userAccess);
      setClaimGroup && setClaimGroup(_objectSpread(_objectSpread({}, claimGroup), {}, {
        user_accesses: [...claimGroup.user_accesses, newUserAccess]
      }));
      const newEntry = _objectSpread(_objectSpread({}, newUserAccess.user), {}, {
        user_access: _objectSpread({}, newUserAccess)
      });
      setEngagementTeam && setEngagementTeam(prev => {
        if (!prev) return {
          clients: [],
          accountants: []
        };
        if (userAccess.roles.includes('accountant')) {
          return _objectSpread(_objectSpread({}, prev), {}, {
            accountants: [...(prev.accountants || []), newEntry]
          });
        } else {
          return _objectSpread(_objectSpread({}, prev), {}, {
            clients: [...(prev.clients || []), newEntry]
          });
        }
      });
      setSelectedUserAccess && setSelectedUserAccess(newUserAccess);
    }, [claimGroup, setSelectedUserAccess, setClaimGroup, setLoading, setEngagementTeam]), useCallback(() => {
      setLoading && setLoading(false);
    }, [setLoading]));
  },
  useUpdateUserAccess(claimGroup, setClaimGroup, setLoading) {
    return useErrorHandling(useCallback(async userAccess => {
      setLoading(true);
      const updatedUserAccess = await userAccessService.update(claimGroup.id, userAccess);
      const updatedClaimGroup = await claimGroupService.get(claimGroup.id);
      setClaimGroup(updatedClaimGroup);
    }, [claimGroup.id, setClaimGroup, setLoading]), useCallback(() => {
      setLoading(false);
    }, [setLoading]));
  },
  useDeleteUserAccess(claimGroup, setClaimGroup, setLoading) {
    return useErrorHandling(useCallback(async userAccessId => {
      setLoading(true);
      await userAccessService.delete(claimGroup.id, userAccessId);
      setClaimGroup(_objectSpread(_objectSpread({}, claimGroup), {}, {
        user_accesses: [...claimGroup.user_accesses.filter(ua => ua.id !== userAccessId)]
      }));
    }, [claimGroup, setClaimGroup, setLoading]), useCallback(() => {
      setLoading(false);
    }, [setLoading]));
  },
  create(claimGroupId, user_access) {
    return fetch("/api/claim_groups/".concat(claimGroupId, "/user_accesses/"), _objectSpread(_objectSpread({}, request.post), {}, {
      body: JSON.stringify({
        user_access
      })
    }));
  },
  update(claimGroupId, user_access) {
    return fetch("/api/claim_groups/".concat(claimGroupId, "/user_accesses/").concat(user_access.id), _objectSpread(_objectSpread({}, request.put), {}, {
      body: JSON.stringify({
        user_access
      })
    }));
  },
  delete(claimGroupId, userAccessId) {
    return fetch("/api/claim_groups/".concat(claimGroupId, "/user_accesses/").concat(userAccessId), _objectSpread({}, request.delete));
  }
};
export default userAccessService;